module.exports = __webpack_public_path__ + "static/img/sign.23f3df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sign.png
// module id = MmaJ
// module chunks = 1